import './App.css';
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { auth, db } from './firebase';

import Login from './auth/Login';
import Register from './auth/Register';
import Header from './panel/Header';
import Menu from './panel/Menu';
import Footer from './panel/Footer';

import Dashboard from './components/Dashboard';
import Forgetpass from './auth/Forgetpass';

import Roomtypes from './components/Roomtypes';
import Rateplans from './components/Rateplans';
import Roomdetails from './components/Roomdetails';
import Roomtarrif from './components/Roomtarrif';
import Roomservices from './components/Roomservices';
import Paymentmode from './components/Paymentmode';
import Roomimages from './components/Roomimages';

import Usermgmt from './components/Users/Usermgmt';

import Approvals from './components/Approvals';
import Bookingtypes from './components/Bookingtypes';
import Allrooms from './components/dashboard/Allrooms';
import Livebookingrooms from './components/dashboard/Livebookingrooms';
import Availablerooms from './components/dashboard/Availablerroms';
import Cleaningrooms from './components/dashboard/Cleaningrooms';

import Allbookingreport from './components/report/Allbookingreport';
import Receptionistreport from './components/report/Receptionistreport';
import Logindetails from './components/report/Logindetails';
import Userlogs from './components/report/Userlogs';
import Paymodewise from './components/report/Paymodewise';
import Bookingtypewise from './components/report/Bookingtypewise';
import Roomtypewiseonline from './components/report/Roomtypewise';
import Collectionreport from './components/report/Collectionreport';
import Checkoutreport from './components/report/Checkoutreport';
import Pendingreport from './components/report/Pendingreport';
import Dcrreport from './components/report/Dcrreport';

import Viewdetails from './components/Viewdetails';
import Livebookings from './components/booking/Livebookings';
import Viewadvance from './components/booking/Viewadvance';
import Advancedetails from './components/booking/Advancedetails';

import Labourcat from './components/payment/Labourcat';
import Labourdetails from './components/payment/Labourdetails';

import Expensehead from './components/Account/Expensehead';
import Paymodecheckouts from './components/report/Paymodecheckouts';
import Hotelinvoice from './components/booking/Hotelinvoice';
import Roomtypewisebooking from './components/report/Roomtypewisebooking';
import AddExpense from './components/Account/Addexpense';
import Expensereport from './components/report/Expensereport';

import Purchaseorder from './components/Purchaseorder';
import Requisitions from './components/Requisitions';
import Viewpo from './components/Viewpo';
import Viewrequisition from './components/Viewrequisition';
import Printpo from './components/Printpo';
import Printrqui from './components/Printrqui';
import Poitemdetails from './components/Poitemdetails';

function App() {
  const [user, setUser] = useState();

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      setUser(user);
    });
  });




  return (
    <div className="wrapper">
      {
        !user ?
          <Router>
            <Routes>
              <Route path='/' element={<Login />} />
              <Route path='/login' element={<Login />} />
              <Route path='/Register' element={<Register />} />
              <Route path='/forgot-password' element={<Forgetpass />} />
            </Routes>
          </Router>
          :
          <>
            <Menu />
            <Header />
            <Router>
              <Routes>
                <Route path='/' element={<Dashboard />} />
                <Route path='/home' element={<Dashboard />} />
                <Route path='/room-types' element={<Roomtypes />} />
                <Route path='/rate-plans' element={<Rateplans />} />
                <Route path='/room-details' element={<Roomdetails />} />
                <Route path='/room-tarrif' element={<Roomtarrif />} />
                <Route path='/room-services' element={<Roomservices />} />
                <Route path='/payment-modes' element={<Paymentmode />} />
                <Route path='/room-type-images' element={<Roomimages />} />
                <Route path='/booking-types' element={<Bookingtypes />} />

                <Route path='/user-mgmt' element={<Usermgmt />} />

                <Route path='/approvals' element={<Approvals />} />

                <Route path='/all-rooms' element={<Allrooms />} />
                <Route path='/live-booking-rooms' element={<Livebookingrooms />} />
                <Route path='/available-rooms' element={<Availablerooms />} />
                <Route path='/cleaning-rooms' element={<Cleaningrooms />} />

                <Route path='/all-booking-report' element={<Allbookingreport />} />
                <Route path='/receptionist-report' element={<Receptionistreport />} />
                <Route path='/login-details' element={<Logindetails />} />
                <Route path='/user-logs' element={<Userlogs />} />
                <Route path='/paymode-wise-report' element={<Paymodewise />} />
                <Route path='/booking-type-report' element={<Bookingtypewise />} />
                <Route path='/room-type-wise-online-bookings' element={<Roomtypewiseonline />} />

                <Route path='/collection-report' element={<Collectionreport />} />
                <Route path='/checkout-report' element={<Checkoutreport />} />
                <Route path='/pending-report' element={<Pendingreport />} />
                <Route path='/dcr-report' element={<Dcrreport />} />
                <Route path='/paymode-checkout-history' element={<Paymodecheckouts />} />

                <Route path='/live-bookings' element={<Livebookings />} />
                <Route path='/view-details/:documentId' element={<Viewdetails />} />
                <Route path='/view-future-bookings' element={<Viewadvance />} />
                <Route path='/view-futuredetails/:documentId' element={<Advancedetails />} />
                <Route path='/print-invoice/:documentId' element={<Hotelinvoice />} />

                <Route path='/staff-category' element={<Labourcat />} />
                <Route path='/staff-details' element={<Labourdetails />} />

                <Route path='/expense-heads' element={<Expensehead />} />
                <Route path='/add-expenses' element={<AddExpense />} />
                <Route path='/expense-report' element={<Expensereport />} />
                <Route path='/roomtypewise-bookings' element={<Roomtypewisebooking />} />

                
                <Route path='/purchase-orders' element={<Purchaseorder />} />
                <Route path='/view-purchase-order' element={<Viewpo />} />
                <Route path='/poitem-details/:documentId' element={<Poitemdetails />} />
                <Route path='/print-po/:documentId' element={<Printpo />} />
                
                <Route path='/requisitions' element={<Requisitions />} />
                <Route path='/view-requisitions' element={<Viewrequisition />} />
                <Route path='/print-requisitions/:documentId' element={<Printrqui />} />



              </Routes>
            </Router>
            <Footer />
          </>
      }

    </div >
  );
}

export default App;
